import axios from "axios";

// FIXME: change in production
export const AXIOS = axios.create({
  baseURL: "https://ultimatetrekkingnepal.com",
});
